<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF DELIVERY ORDER</b></h5>
    <hr />

    <TableDeliveryOrderIndex
      :fields="fields.fields"
      :filter="this.filter"
      :page="this.page"
      :date="this.date"
    />
  </b-card>
</template>

<script>
import TableDeliveryOrderIndex from "@/table/user/deliveryOrder/TableDeliveryOrderIndex";

export default {
  data() {
    return {
      items: [],
      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Status",
            key: "status",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      },
      filter: "",
      page: "",
      date: ""
    };
  },
  created() {
    if (this.$route.query.filter !== undefined) {
      this.filter = this.$route.query.filter;
      this.page = this.$route.query.page;
      this.date = this.$route.query.date;
    }
  },
  methods: {
    getDO() {
      this.$store.dispatch("getDO", { category: 4 }).then(res => {
        let no = 0;
        res.data.data.forEach(element => {
          no = no + 1;
          // let type = element.type === 1 ? "UHT" : "Pasteurized";
          this.items.push({
            no: no,
            date: element.date,
            id: element.delivery_id
          });
        });
        this.totalRows = this.items.length;
      });
    }
  },
  components: {
    TableDeliveryOrderIndex
  }
};
</script>
<style lang="css" scoped></style>
